import { Divider } from 'antd';
import styled from 'styled-components';

export const PickerContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;

    .tag-picker-dropdown .ant-select-item.tag-picker-divider {
        padding: 3px 12px;
        min-height: 0;
        cursor: default;
    }
`;

export const SearchContainer = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
`;

export const TagsDivider = styled(Divider)`
    border-color: #D9D9D9;
    margin: 0 !important;
`;